module.exports = __webpack_public_path__ + "static/img/voroStand1.1dd4bcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/makeVoroStand/imgs/voroStand1.jpg
// module id = Tz20
// module chunks = 2